<template>
  <div class="box3">
    <pageTitle
      title="大模型时代，我们皆大有可为"
      text="为不同基础人群，量身定制学习内容和解决方案"
      titleColor="#081745"
      titColor="#081745"
    />
    <div class="content">
      <h1 class="title">
        有兴趣，想利用大模型做应用的人员
        <i>适学人群</i>
      </h1>
      <div class="item">
        <div class="itemLeft itemLeft1">Prompt<br />工程</div>
        <div class="itemRight">
          <div class="wrapper">
            提示词撰写技巧
            <i>模型适配方案</i>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="itemLeft itemLeft2">平台<br />应用</div>
        <div class="itemRight">
          <div class="wrapper">
            百度千帆大模型平台<br />阿里云PAI平台
            <i>模型适配方案</i>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="itemLeft itemLeft3">
          Lang<br />
          Chain<br />
          工具
        </div>
        <div class="itemRight">
          <div class="wrapper">
            Models(模型)、Prompt(提示)<br />
            Chains(链)、Agents (代理)<br />
            Memory(记忆)、Indexes (索引)
            <i>模型适配方案</i>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="itemRight">
          <div class="wrapper">
            基于LangChain大模型开发工具，搭建物流行业信息本地知识库问答系统
            <i>解决实际问题</i>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="itemRight">
          <div class="wrapper">
            AI工程师、大模型开发工程师、大模型训练研发工程师 ...
            <i>胜任岗位</i>
          </div>
        </div>
      </div>
    </div>
    <div class="content content2">
      <h1 class="title">
        程序员Java前端鸿蒙开发者
        <i>适学人群</i>
      </h1>
      <div class="item">
        <div class="itemLeft itemLeft1">Prompt<br />工程</div>
        <div class="itemRight">
          <div class="wrapper">
            提示词撰写技巧
            <i>模型适配方案</i>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="itemLeft itemLeft2">平台<br />应用</div>
        <div class="itemRight">
          <div class="wrapper">
            百度千帆大模型平台<br />阿里云PAI平台
            <i>模型适配方案</i>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="itemLeft itemLeft3">
          Lang<br />
          Chain<br />
          工具
        </div>
        <div class="itemRight">
          <div class="wrapper">
            Models(模型)、Prompt(提示)<br />
            Chains(链)、Agents (代理)<br />
            Memory(记忆)、Indexes (索引)
            <i>模型适配方案</i>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="itemLeft itemLeft4">
          模型<br />
          微调
        </div>
        <div class="itemRight">
          <div class="wrapper">
            ChatGPT模型、LLaMA模型、<br />
            ChatGLM模型、BLOOM模型
            <i>模型适配方案</i>
          </div>
          <div class="wrapper wrapper2">
            Prefix-Tuning、LoRA ……
            <i>模型适配方案</i>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="itemRight">
          <div class="wrapper">
            基于大模型微调技术，实现多场景业务领域的应用，如构建智能问答系统、评价决策系统等
            <i>解决实际问题</i>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="itemRight">
          <div class="wrapper">
            大模型算法工程师、人工智能大模型AI前沿技术专家、大语言模型精调算法工程师
            ...
            <i>胜任岗位</i>
          </div>
        </div>
      </div>
    </div>
    <div class="content3">
      <h1>前置学习内容</h1>
      <p>我们为零基础学员准备了免费前置课程，助力快速通关，入营即可解锁~</p>
      <div class="inner">
        <span>
          <p>
            <img src="../../../assets/coursePage/ai2/box3/python.png" />
            <i>Python基础</i>
          </p>
          <b>Python基础语法</b>
        </span>
        <span>
          <p>
            <img src="../../../assets/coursePage/ai2/box3/study.png" />
            <i>深度学习基础</i>
          </p>
          <b>神经网络、Pytorch框架</b>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    // let that = this;
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box3 {
  padding: 80px 0 60px;
  width: 100%;
  background: #f9fbff;
  .content {
    margin: 48px auto 16px;
    background: url("../../../assets/coursePage/ai2/box3/bg01.png") no-repeat;
    background-size: cover;
    background-position: center;

    width: 686px;
    padding: 32px;
    box-sizing: border-box;
    .title {
      background: rgba(255, 121, 47, 0.06);
      border-radius: 16px;
      border: 2px solid #ffbe9a;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #082046;
      line-height: 80px;
      height: 80px;
      text-align: center;
      font-style: normal;
      margin-bottom: 40px;
      position: relative;
      i {
        position: absolute;
        top: -18px;
        left: 0;
        background: linear-gradient(270deg, #ff9f67 0%, #ff782d 100%);
        border-radius: 200px 200px 200px 0px;
        backdrop-filter: blur(14px);
        width: 138px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 24px;
        color: #ffffff;
        line-height: 34px;
        text-align: center;
        font-style: normal;
      }
    }
   
    .item {
      display: flex;
      margin-bottom: 34px;
      .itemLeft {
        background: rgba(255, 255, 255, 0.8);
        border-radius: 8px;
        border: 2px solid #ffffff;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #082046;
        line-height: 34px;
        height: 100%;
        text-align: center;
        font-style: normal;
        margin-right: 16px;
        width: 94px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .itemLeft1 {
        height: 96px;
      }
      .itemLeft2 {
        height: 130px;
      }
      .itemLeft3 {
        height: 164px;
      }
      .itemLeft4 {
        height: 270px;
      }
      .itemRight {
        flex: 1;

        .wrapper {
          height: 100%;
          background: rgba(255, 255, 255, 0.8);
          border-radius: 8px;
          border: 2px solid #ffffff;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 24px;
          color: #082046;
          line-height: 34px;
          text-align: left;
          font-style: normal;
          padding: 38px 0 24px 32px;
          box-sizing: border-box;
          width: 100%;
          position: relative;
        }
        .wrapper2 {
          margin-top: 34px;
          padding-bottom: 20px;
        }
        i {
          position: absolute;
          left: -2px;
          top: -18px;
          height: 40px;
          background: linear-gradient(270deg, #faf2e5 0%, #f5e1bf 100%);
          border-radius: 200px 200px 200px 0px;
          backdrop-filter: blur(14px);
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 24px;
          color: #845200;
          line-height: 40px;
          text-align: center;
          font-style: normal;
          padding: 0 18px;
        }
      }
    }
    .item:nth-child(5){
      .itemRight {
        .wrapper {
          height: auto;
        }
        .wrapper2:last-child{padding: 40px 0 30px 32px;}
      }
    }
    .item:last-child {
      margin-bottom: 0;
    }
  }
  .content2 {
    background: url("../../../assets/coursePage/ai2/box3/bg02.png") no-repeat;
    background-size: cover;
    background-position: center;
    margin-top: 16px !important;
    .title {
      background: rgba(255, 225, 209, 0.4);
      border-radius: 16px;
      border: 2px solid #fcbf9e;
      i {
        background: linear-gradient(270deg, #fe7376 0%, #fe555b 100%);
      }
    }
    .itemRight {
      .wrapper {
        i {
          background: linear-gradient(270deg, #f5e2db 0%, #ffcdbb 100%);
          color: #9c3700;
        }
      }
    }
  }
  .content3 {
    background: #b8d5ff;
    border-radius: 28px;
    padding: 20px 30px 30px;
    margin: 24px 32px 0;
    > h1 {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 36px;
      color: #002048;
      line-height: 68px;
      text-align: left;
      font-style: normal;
    }
    > p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #002048;
      line-height: 44px;
      text-align: left;
      font-style: normal;
    }
    .inner {
      margin-top: 28px;
      display: flex;
      span {
        background: #e1eeff;
        border-radius: 24px;
        border: 2px solid #ffffff;
        padding: 36px 0;
        width: 300px;
        p {
          display: flex;
          align-items: center;
          padding: 0 26px;
          img {
            width: 32px;
            margin-right: 14px;
          }
          i {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 32px;
            color: #0060ff;
            line-height: 44px;
            text-align: left;
            font-style: normal;
          }
        }
        b {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 26px;
          color: #051648;
          line-height: 36px;
          text-align: left;
          font-style: normal;
          text-align: center;
          margin-top: 20px;
          display: block;
        }
      }
      span:first-child {
        margin-right: 22px;
      }
    }
  }
}
</style>
